import React, { Fragment, useState } from 'react';
import { Button, Form, FloatingLabel, Row, Col, Container, Accordion } from 'react-bootstrap';
import PartidoService from '../../../../services/partido';
import { Link } from 'react-router-dom';
import Exportar from '../../../../components/shared/export'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDatabase } from '@fortawesome/free-solid-svg-icons';



const FormBusca = (props) => {
    const [ano, setAno] = useState("");

    const busca = async (query) => {
        if (query === "") {
            await props.fetchPartidoIn()
            setAno("")
        } else {
            var response = await PartidoService.buscar(query)
            if (response.data.length >= 1) {
                props.setPartido(response.data)
                props.setVazio(false)
                setAno("")
            } else {
                props.setVazio(true)
                setAno("")
            }
        }
    }

    const preparaQuery = async () => {
        let prepQuery = "";
        if (ano) prepQuery = prepQuery + `ano=${ano}`;
        return prepQuery;
    }

    const handleKeyDown = async (e) => {
        e.preventDefault();
        let finalQuery = await preparaQuery();
        await busca(finalQuery)
    }

    return (
        <Fragment>
            <Container>
                <div className="da-espaco">
                    <Row xs={1} lg={4}>
                        <Col xs={12} lg={2}>
                            <Form.Group className="mb-3" controlId="ano">
                                <FloatingLabel
                                    label="Ano"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="ano"
                                        value={ano}
                                        onChange={e => setAno(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Button onClick={async (e) => handleKeyDown(e)} type='button' variant='primary'>Buscar</Button>
                        </Col>
                        <Col xs={12} lg={1}>
                            <Link to='/'>
                                <Button type='button' variant='danger'>Voltar</Button>
                            </Link>
                        </Col>
                    </Row>
                    <Accordion>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header><strong>Dados Abertos <FontAwesomeIcon icon={faDatabase} /></strong></Accordion.Header>
                            <Accordion.Body>
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <Exportar data={props.recursos} nome={"Recursos"} />
                                    </Col>
                                </Row>
                                <br />
                                <Row xs={1}>
                                    <Col xs={12}>
                                        <a href="https://documenter.getpostman.com/view/19738229/2sA3BrWp4P#091e8f27-d0ca-49fd-bc0c-9b2cf7c066d4" target='_blank'>
                                            <Button>API e sua documentação</Button>
                                        </a>
                                    </Col>
                                </Row>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            </Container>
        </Fragment>
    )
}

export default FormBusca